"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccommodationQuality = exports.AccommodationStanding = void 0;
const infrastructure_1 = require("../../../infrastructure");
const utils_1 = require("@leavy/utils");
var AccommodationStanding;
(function (AccommodationStanding) {
    AccommodationStanding["FUNCTIONAL"] = "functional";
    AccommodationStanding["MODERN"] = "modern";
    AccommodationStanding["LUXURIOUS"] = "luxurious";
})(AccommodationStanding = exports.AccommodationStanding || (exports.AccommodationStanding = {}));
class AccommodationQuality extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.standing) && utils_1.Guard.Enum.isEnumMember(AccommodationStanding)(this.standing)
            && utils_1.Guard.isNotNullish(this.luminosity) && this.luminosity > 0 && this.luminosity <= 5
            && utils_1.Guard.isNotNullish(this.furnishings) && this.furnishings > 0 && this.furnishings <= 5
            && utils_1.Guard.isNotNullish(this.bedding) && this.bedding > 0 && this.bedding <= 5
            && utils_1.Guard.isNotNullish(this.bathrooms) && this.bathrooms > 0 && this.bathrooms <= 5);
    }
    toPlain() {
        return { ...(this) };
    }
}
exports.AccommodationQuality = AccommodationQuality;
//# sourceMappingURL=AccommodationQuality.js.map